import { clsx, type ClassValue } from 'clsx'
import { format, isValid } from 'date-fns'
import { sv } from 'date-fns/locale'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Formats a date string in Swedish, returning fallback for missing or unparseable dates
// (e.g. AI-parsed invoices with "null" as date) instead of throwing like date-fns does
export function formatDate(value: string | undefined | null, pattern = 'd MMM yyyy', fallback = '-') {
  if (!value) return fallback
  const date = new Date(value)
  return isValid(date) ? format(date, pattern, { locale: sv }) : fallback
}

// Drops empty strings so unset filters aren't sent as ?search=&workshop=
export function toQueryParams<T extends object>(params: T) {
  return Object.fromEntries(Object.entries(params).filter(([, value]) => value !== '' && value != null))
}
